/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

@Injectable()
export class ApiUrlInterceptor implements HttpInterceptor {
  constructor(private environmentService: EnvironmentService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith('/api')) {
      const apiUrl = this.environmentService.getEnvironment().apiUrl;
      const path = req.url.substring(4);
      const newUrl = `${apiUrl}${path}`;

      req = req.clone({ url: newUrl });
    }

    return next.handle(req);
  }
}